module.exports = __webpack_public_path__ + "static/media/louise_logo.1b1c294a.svg";